import React, {useContext} from 'react'
import ContentAlert from 'views/AppLocals/ContentAlert'
import {LoadingWrapper, renderOwnChild} from 'views/Shared'
import UserContext from '../UserContext'
import UserNav from './UserNav'
import {RequiredSystemAdmin} from "../../../../components/RequiredAdmin";
import {ActionPanel} from "../../AdminPanel";
import {TbHeartCheck, TbHeartX} from "react-icons/tb";

const UserAdminPanel = ({item, open = true}) => {
    if (!!!open) {
        return null
    }

    return (
        <ActionPanel
            item={item}
            title="administration panel"
            actions={[
                {
                    key: "ADD_TO_RECOMMENDATION",
                    label: 'add to recommendation',
                    icon: <TbHeartCheck size={15} className="text-color-400"/>,
                },
                {
                    key: "REMOVE_FROM_RECOMMENDATION",
                    label: 'remove from recommendation',
                    icon: <TbHeartX size={15} className="text-color-400"/>,
                },
            ]}
        />
    )
}

const UserContent = ({Wrapper = renderOwnChild}) => {
    const {user} = useContext(UserContext)
    return (
        <Wrapper>
            <LoadingWrapper
                center={false}
                isLoading={!user}>
                <ContentAlert entity={user} />
            </LoadingWrapper>
            <div className="space-y-3">
                <RequiredSystemAdmin>
                    <UserAdminPanel item={user}/>
                </RequiredSystemAdmin>
                <UserNav/>
            </div>
        </Wrapper>
    )
}

export default UserContent
